import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=271c6e80&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=271c6e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c6e80",
  null
  
)

export default component.exports